import request from '@/shared/api/request';

/**
 *
 * Verify user and allow to login.
 *
 * @returns {Promise}
 */
export const verify = (code: string): Promise<void> =>
  request({
    url: '/account/login/verify/',
    withCredentials: true,
    method: 'POST',
    data: { code },
  });
